// https://open.spotify.com/intl-de/playlist/37i9dQZF1FbGYSbcGyGDYM?si=35a9ece5476d4ae2
// https://open.spotify.com/playlist/37i9dQZF1FbGYSbcGyGDYM?si=35a9ece5476d4ae2
// https://open.spotify.com/embed/show/6wPqbSlsvoi3Rgjjc2Sn4R?utm_source=generator

export function parseSpotifyURL(link: string) {
    const SPOTIFY_REGEX =
        /^https:\/\/open\.spotify\.com\/(?:intl-[a-z]+\/)?(?:embed\/)?(episode|show|playlist)\/([a-zA-Z0-9]+)(?:\/[a-z]+)?(\?.*)?$/;

    const match = SPOTIFY_REGEX.exec(link);

    if (!match) {
        return { id: null, type: null, validLink: false };
    }

    const type = match[1];
    const id = match[2];

    return { id, type, validLink: true };
}
